import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './About.css';

const About: React.FC = () => {
  const { language } = useLanguage();

  const programs = {
    youth: [
      {
        icon: '🤖',
        titleAr: 'روبوتيكا للأطفال والشباب',
        titleEn: 'Robotics for Kids & Youth',
        descAr: 'تطوير المهارات التقنية والإبداعية من خلال بناء وبرمجة الروبوتات، مع التركيز على التعلم العملي والتفكير النقدي.',
        descEn: 'Develop technical and creative skills through building and programming robots, with emphasis on hands-on learning and critical thinking.'
      },
      {
        icon: '🧩',
        titleAr: 'التفكير المنطقي وحل المشكلات',
        titleEn: 'Logical Thinking & Problem Solving',
        descAr: 'تعزيز مهارات التفكير المنطقي والتحليلي من خلال الألعاب والتحديات التفاعلية المصممة لتطوير عقلية هندسية.',
        descEn: 'Enhance logical and analytical thinking skills through games and interactive challenges designed to develop an engineering mindset.'
      },
      {
        icon: '🖥️',
        titleAr: 'البرمجة للمبتدئين والمتقدمين',
        titleEn: 'Coding for Beginners & Advanced',
        descAr: 'دورات مخصصة لمختلف المستويات، بدءًا من مفاهيم البرمجة الأساسية وصولاً إلى تطوير التطبيقات والألعاب والذكاء الاصطناعي.',
        descEn: 'Tailored courses for various levels, from basic coding concepts to app development, game creation, and AI exploration.'
      },
      {
        icon: '🎮',
        titleAr: 'الألعاب والتفكير للأطفال ذوي الاحتياجات الخاصة',
        titleEn: 'Games & Thinking for Kids with Special Needs',
        descAr: 'برامج مصممة خصيصًا لدعم الأطفال ذوي الاحتياجات الخاصة، باستخدام الألعاب التفاعلية والتكنولوجيا المساعدة لتعزيز المهارات المعرفية والاجتماعية.',
        descEn: 'Specially designed programs to support children with special needs, using interactive games and assistive technology to enhance cognitive and social skills.'
      },
      {
        icon: '🎨',
        titleAr: 'التفكير الإبداعي والتصميم',
        titleEn: 'Creative Thinking & Design',
        descAr: 'تنمية مهارات التفكير خارج الصندوق من خلال ورش عمل تفاعلية تدمج بين التصميم والفنون والتقنية، وتشجع الأطفال على الابتكار وتحدي الأفكار التقليدية.',
        descEn: 'Develop out-of-the-box thinking through interactive workshops that blend design, arts, and technology, encouraging children to innovate and challenge conventional ideas.'
      },
      {
        icon: '📊',
        titleAr: 'تحليل الأنماط وهندسة التفكير',
        titleEn: 'Pattern Analysis & Thinking Engineering',
        descAr: 'استكشاف العلاقات والأنماط في العالم من حولنا، وتطوير مهارات التحليل والاستنتاج، وحل المشكلات المعقدة من خلال استخدام مناهج التفكير المنظم.',
        descEn: 'Explore relationships and patterns in the world around us, developing analytical skills and the ability to solve complex problems through systematic thinking approaches.'
      },
      {
        icon: '🌐',
        titleAr: 'الأخلاقيات الرقمية والتوعية التكنولوجية',
        titleEn: 'Digital Ethics & Tech Literacy',
        descAr: 'إعداد جيل واعٍ تكنولوجيًا قادر على التمييز بين المعلومات الصحيحة والمضللة، وفهم تأثير التكنولوجيا على المجتمع، وممارسة المواطنة الرقمية المسؤولة.',
        descEn: 'Prepare a tech-savvy generation able to discern between accurate and misleading information, understand technology\'s impact on society, and practice responsible digital citizenship.'
      },
      {
        icon: '🔄',
        titleAr: 'التكيف والمرونة في عالم سريع التغير',
        titleEn: 'Adaptability & Resilience in a Rapidly Changing World',
        descAr: 'تنمية مهارات التكيف والمرونة لمواجهة التحديات المستقبلية، من خلال التعرض لسيناريوهات مختلفة والتدريب على إدارة التغيير والتعامل مع عدم اليقين.',
        descEn: 'Develop adaptability and resilience skills to face future challenges, through exposure to varied scenarios and training on change management and dealing with uncertainty.'
      },
      {
        icon: '🌱',
        titleAr: 'الاستدامة والابتكار الأخضر',
        titleEn: 'Sustainability & Green Innovation',
        descAr: 'تمكين الشباب من فهم التحديات البيئية واستخدام التكنولوجيا والذكاء الاصطناعي لابتكار حلول مستدامة تساهم في بناء مستقبل أكثر خضرة وصحة.',
        descEn: 'Empower youth to understand environmental challenges and use technology and AI to innovate sustainable solutions that contribute to building a greener, healthier future.'
      },
      {
        "icon": "🛡️",
        "titleAr": "التعايش مع الذكاء الاصطناعي",
        "titleEn": "AI Coexistence & Human Advantage",
        "descAr": "تعليم الشباب كيفية العمل جنبًا إلى جنب مع أنظمة الذكاء الاصطناعي، وتطوير المهارات البشرية الفريدة التي لا يمكن للآلات تقليدها، مثل الذكاء العاطفي والإبداع والتعاطف.",
        "descEn": "Teach youth how to work alongside AI systems while developing uniquely human skills that machines cannot replicate, such as emotional intelligence, creativity, and empathy."
      },
      {
        "icon": "⚖️",
        "titleAr": "فهم تأثير الذكاء الاصطناعي على المجتمع",
        "titleEn": "Understanding AI's Social Impact",
        "descAr": "استكشاف التغييرات الاجتماعية والاقتصادية التي يحدثها الذكاء الاصطناعي، وتمكين الشباب من التفكير النقدي في قضايا العدالة والمساواة والخصوصية في عصر الذكاء الاصطناعي.",
        "descEn": "Explore the social and economic changes brought by AI, empowering youth to think critically about issues of justice, equity, and privacy in the age of artificial intelligence."
      },
      {
        "icon": "🔍",
        "titleAr": "ما وراء الخوارزميات: التفكير النقدي في عصر الذكاء الاصطناعي",
        "titleEn": "Beyond Algorithms: Critical Thinking in the AI Era",
        "descAr": "تطوير مهارات التفكير النقدي المتقدمة للتعامل مع المحتوى الذي ينتجه الذكاء الاصطناعي، وتعلم كيفية تقييم مصداقية المعلومات، واكتشاف التحيزات، واتخاذ قرارات مستقلة في عالم غني بالمعلومات.",
        "descEn": "Develop advanced critical thinking skills to navigate AI-generated content, learning how to evaluate information credibility, detect biases, and make independent decisions in an information-rich world."
      }
    ],
    professional: [
      {
        icon: '⚙️',
        titleAr: 'أدوات الذكاء الاصطناعي للمحترفين',
        titleEn: 'AI Tools for Professionals',
        descAr: 'ورش عمل عملية تعلم المحترفين كيفية تسخير أدوات الذكاء الاصطناعي لتعزيز إنتاجيتهم في مجالات عملهم.',
        descEn: 'Practical workshops teaching professionals how to harness AI tools to enhance productivity in their fields.'
      },
      {
        icon: '📊',
        titleAr: 'تحليل البيانات واتخاذ القرارات',
        titleEn: 'Data Analysis & Decision Making',
        descAr: 'دورات متخصصة في استخدام الذكاء الاصطناعي لتحليل البيانات الكبيرة واستخلاص الرؤى القيمة لاتخاذ قرارات أفضل وأسرع.',
        descEn: 'Specialized courses in using AI for big data analysis and extracting valuable insights for better and faster decision-making.'
      },
      {
        icon: '🔄',
        titleAr: 'التحول الرقمي للمؤسسات',
        titleEn: 'Digital Transformation for Organizations',
        descAr: 'خدمات استشارية وتدريبية شاملة لمساعدة المؤسسات على دمج تقنيات الذكاء الاصطناعي في عملياتها وخدماتها.',
        descEn: 'Comprehensive consulting and training services to help organizations integrate AI technologies into their operations and services.'
      },{
          "icon": "🏫",
          "titleAr": "الذكاء الاصطناعي للمعلمين والتربويين",
          "titleEn": "AI for Educators & Teachers",
          "descAr": "تمكين المعلمين من استخدام أدوات الذكاء الاصطناعي لتخصيص المناهج، وإنشاء مواد تعليمية تفاعلية، وتقييم أعمال الطلاب بكفاءة، مع الحفاظ على النهج التربوي المتمركز حول الإنسان والقيم التعليمية.",
          "descEn": "Empower educators to leverage AI tools for curriculum customization, interactive teaching material creation, and efficient student assessment, while maintaining a human-centered pedagogical approach and educational values."
        },
        {
          "icon": "⚕️",
          "titleAr": "الذكاء الاصطناعي في المجال الصحي",
          "titleEn": "AI in Healthcare & Medical Practice",
          "descAr": "تدريب الأطباء والعاملين في المجال الصحي على دمج أدوات الذكاء الاصطناعي في الممارسة الطبية، بما في ذلك تحليل البيانات الطبية، والتشخيص المساعد، وتحسين رعاية المرضى، مع مراعاة الجوانب الأخلاقية والخصوصية.",
          "descEn": "Train doctors and healthcare professionals to integrate AI tools into medical practice, including medical data analysis, diagnostic assistance, and patient care enhancement, while addressing ethical considerations and privacy concerns."
        },
        {
          "icon": "🛒",
          "titleAr": "الذكاء الاصطناعي في التجارة والتسويق",
          "titleEn": "AI for Retail & Marketing Professionals",
          "descAr": "مساعدة المتخصصين في التجارة والتسويق على استخدام الذكاء الاصطناعي لتحليل سلوك المستهلك، وتحسين استراتيجيات التسويق، وتخصيص تجارب التسوق، وزيادة الكفاءة التشغيلية مع الحفاظ على الأصالة والعلاقات مع العملاء.",
          "descEn": "Help retail and marketing professionals harness AI for consumer behavior analysis, marketing strategy optimization, shopping experience personalization, and operational efficiency enhancement while maintaining authenticity and customer relationships."
        }
    ],
    career: [
      {
        icon: '🚀',
        titleAr: 'مسار مطوري الذكاء الاصطناعي',
        titleEn: 'AI Developer Career Track',
        descAr: 'برنامج شامل للخريجين الجدد والمهندسين ذوي الخبرة لاكتساب المهارات اللازمة في علوم البيانات والتعلم الآلي وهندسة الذكاء الاصطناعي.',
        descEn: 'Comprehensive program for new graduates and experienced engineers to gain necessary skills in data science, machine learning, and AI engineering.'
      },
      {
        icon: '🏗️',
        titleAr: 'بناء المشاريع والخبرة العملية',
        titleEn: 'Project Building & Practical Experience',
        descAr: 'فرص للعمل على مشاريع حقيقية مع الشركات والمؤسسات، مما يوفر خبرة عملية قيمة وإضافة مهمة للسيرة الذاتية.',
        descEn: 'Opportunities to work on real-world projects with companies and institutions, providing valuable practical experience and portfolio enhancement.'
      },
      {
        icon: '🌐',
        titleAr: 'شبكة المهنيين والفرص الوظيفية',
        titleEn: 'Professional Network & Job Opportunities',
        descAr: 'الوصول إلى شبكة واسعة من المهنيين وفرص التوظيف من خلال شراكاتنا مع الشركات التقنية والمؤسسات في المنطقة.',
        descEn: 'Access to an extensive network of professionals and employment opportunities through our partnerships with tech companies and institutions in the region.'
      },
      {
        "icon": "🔄",
        "titleAr": "إعادة تأهيل المهارات في عصر الذكاء الاصطناعي",
        "titleEn": "AI-Era Reskilling & Career Pivoting",
        "descAr": "برنامج شامل لمساعدة المهنيين على تقييم مهاراتهم الحالية في ضوء تقدم الذكاء الاصطناعي، وتحديد المجالات المستقبلية الآمنة من الأتمتة، واكتساب المهارات اللازمة للتحول المهني الناجح.",
        "descEn": "A comprehensive program helping professionals assess their current skills in light of AI advancement, identify future-proof domains, and acquire necessary skills for successful career transitions."
      },
      {
        "icon": "🤝",
        "titleAr": "الشراكة مع الذكاء الاصطناعي في بيئة العمل",
        "titleEn": "Human-AI Collaboration in the Workplace",
        "descAr": "تدريب عملي على العمل بفعالية جنبًا إلى جنب مع أنظمة الذكاء الاصطناعي، وتصميم سير العمل المثالي بين الإنسان والآلة، والاستفادة من نقاط القوة البشرية الفريدة مع الاستفادة من قدرات الذكاء الاصطناعي.",
        "descEn": "Practical training on working effectively alongside AI systems, designing optimal human-machine workflows, and leveraging uniquely human strengths while benefiting from AI capabilities."
      },
      {
        "icon": "🚀",
        "titleAr": "ريادة الأعمال المدعومة بالذكاء الاصطناعي",
        "titleEn": "AI-Powered Entrepreneurship",
        "descAr": "تمكين رواد الأعمال المستقبليين من استخدام الذكاء الاصطناعي لتحديد الفرص في السوق، وتطوير نماذج أعمال مبتكرة، وتنفيذ حلول قابلة للتطبيق مع استثمار أقل للموارد، مع التركيز على المشاريع ذات التأثير الاجتماعي الإيجابي.",
        "descEn": "Empower future entrepreneurs to use AI to identify market opportunities, develop innovative business models, and implement viable solutions with fewer resources, focusing on ventures with positive social impact."
      }
    ]
  };


  return (
    <section id="about" className="about">
      <div className="about-container">
        <h2 className={language === 'ar' ? 'visible' : 'hidden'}>عن الأكاديمية</h2>
        <h2 className={language === 'en' ? 'visible' : 'hidden'}>About Us</h2>

        <div className="about-content">
          <div className="about-text">
            <p className={language === 'ar' ? 'visible' : 'hidden'}>
              أكاديمية الذكاء الاصطناعي هي شركة ناشئة رائدة ومكرسة لتعزيز المعرفة والابتكار في مجال الذكاء الاصطناعي وعلوم الحاسوب. نقدم تدريبًا وتعليمًا شاملًا في المجالات العلمية والمهنية لجماهير متنوعة تشمل الأطفال والشباب والمحترفين والخريجين الجدد والمؤسسات.
            </p>
            <p className={language === 'en' ? 'visible' : 'hidden'}>
              AI Academy is a leading startup dedicated to advancing knowledge and innovation in the fields of artificial intelligence and computer science. We offer comprehensive training and education in both scientific and professional domains for diverse audiences, including children, youth, professionals, recent graduates, and institutions.
            </p>

            <p className={language === 'ar' ? 'visible' : 'hidden'}>
              مهمتنا هي سد الفجوة بين المعرفة النظرية والتطبيقات العملية للذكاء الاصطناعي، وتمكين طلابنا من تسخير قوة الذكاء الاصطناعي لحل المشكلات العملية ودفع الابتكار في مختلف القطاعات والمراحل العمرية.
            </p>
            <p className={language === 'en' ? 'visible' : 'hidden'}>
              Our mission is to bridge the gap between theoretical knowledge and practical applications of AI, enabling our students of all ages and career stages to harness the power of artificial intelligence to solve real-world problems and drive innovation in various sectors.
            </p>
          </div>
        </div>

        <div id="programs" className="programs-section">
          <h3 className={language === 'ar' ? 'visible' : 'hidden'}>برامجنا المتميزة</h3>
          <h3 className={language === 'en' ? 'visible' : 'hidden'}>Our Distinguished Programs</h3>

          <div id="youth-programs" className="program-category">
            <h4 className={language === 'ar' ? 'visible' : 'hidden'}>برامج الأطفال والشباب</h4>
            <h4 className={language === 'en' ? 'visible' : 'hidden'}>Children & Youth Programs</h4>

            <div className="program-items">
              {programs.youth.map((program, index) => (
                <div className="program-item" key={`youth-${index}`}>
                  <div className="program-icon">{program.icon}</div>
                  <div className="program-text">
                    <h5 className={language === 'ar' ? 'visible' : 'hidden'}>{program.titleAr}</h5>
                    <h5 className={language === 'en' ? 'visible' : 'hidden'}>{program.titleEn}</h5>
                    <p className={language === 'ar' ? 'visible' : 'hidden'}>{program.descAr}</p>
                    <p className={language === 'en' ? 'visible' : 'hidden'}>{program.descEn}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div id="professional-programs" className="program-category">
            <h4 className={language === 'ar' ? 'visible' : 'hidden'}>برامج المحترفين</h4>
            <h4 className={language === 'en' ? 'visible' : 'hidden'}>Professional Programs</h4>

            <div className="program-items">
              {programs.professional.map((program, index) => (
                <div className="program-item" key={`prof-${index}`}>
                  <div className="program-icon">{program.icon}</div>
                  <div className="program-text">
                    <h5 className={language === 'ar' ? 'visible' : 'hidden'}>{program.titleAr}</h5>
                    <h5 className={language === 'en' ? 'visible' : 'hidden'}>{program.titleEn}</h5>
                    <p className={language === 'ar' ? 'visible' : 'hidden'}>{program.descAr}</p>
                    <p className={language === 'en' ? 'visible' : 'hidden'}>{program.descEn}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div id="career-programs" className="program-category">
            <h4 className={language === 'ar' ? 'visible' : 'hidden'}>برامج التطوير المهني والوظيفي</h4>
            <h4 className={language === 'en' ? 'visible' : 'hidden'}>Career Development Programs</h4>
            
            <div className="program-items">
              {programs.career.map((program, index) => (
                <div className="program-item" key={`career-${index}`}>
                  <div className="program-icon">{program.icon}</div>
                  <div className="program-text">
                    <h5 className={language === 'ar' ? 'visible' : 'hidden'}>{program.titleAr}</h5>
                    <h5 className={language === 'en' ? 'visible' : 'hidden'}>{program.titleEn}</h5>
                    <p className={language === 'ar' ? 'visible' : 'hidden'}>{program.descAr}</p>
                    <p className={language === 'en' ? 'visible' : 'hidden'}>{program.descEn}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        

      </div>
    </section>
  );
};

export default About;